// Global state composable
// Provides access to global store for miscellaneous global state including app context

import { useNuxtApp } from 'nuxt/app'

import { useGlobalStore, APP_NAMES, type AppType } from '../stores/global.store'
import {
  isDesktop as isDesktopViewport,
  isMobile as isMobileViewport,
  isMobileOrTablet as isMobileOrTabletViewport,
  isTablet as isTabletViewport,
  isDesktopSSR,
  isMobileOrTabletSSR,
  isMobileSSR,
  isTabletSSR,
} from '../utils/core.utils'

/**
 * Access global store state and actions
 * Includes app context, theme, language, and other global state
 */
export function useGlobal() {
  const globalStore = useGlobalStore()

  return {
    // App-related state
    appType: globalStore.appType,
    isClientportal: globalStore.isClientportal,
    isGokollab: globalStore.isGokollab,
    isMeet: globalStore.isMeet,
    isCourses: globalStore.isCourses,

    setAppType: globalStore.setAppType,
    isMobile: function () {
      if (process.client) {
        return isMobileViewport()
      }

      // Server-only compute
      const nuxtApp = useNuxtApp()
      return isMobileSSR(nuxtApp)
    },
    isTablet: function () {
      if (process.client) {
        return isTabletViewport()
      }

      const nuxtApp = useNuxtApp()
      return isTabletSSR(nuxtApp)
    },
    isDesktop: function () {
      if (process.client) {
        return isDesktopViewport()
      }

      const nuxtApp = useNuxtApp()
      return isDesktopSSR(nuxtApp)
    },
    isMobileOrTablet: function () {
      if (process.client) {
        return isMobileOrTabletViewport() || window.innerWidth < 768
      }

      const nuxtApp = useNuxtApp()
      return isMobileOrTabletSSR(nuxtApp)
    },

    // Future global state will be accessible here
    // theme: globalStore.theme,
    // language: globalStore.language,
    // isLoading: globalStore.isLoading,
    // notifications: globalStore.notifications,
  }
}

/**
 * Set app type (called during app initialization)
 * Convenience function for initialization
 */
export function setAppType(type: AppType) {
  const globalStore = useGlobalStore()
  globalStore.setAppType(type)
}

// Re-export constants for convenience
export { APP_NAMES, type AppType }
